/**
 * @file 删除feed
 * @author liudaoyu
 * {@link http://api.umucdn.cn/project/76/wiki}
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IDeleteFeedOutput {
    status: number;
}

export interface IDeleteFeedInput {
    feed_id: number;
}

export const deleteFeed = (data: IDeleteFeedInput): Promise<IDeleteFeedOutput> => {
    return fetchData(Api.CLASS_DELETE_FEED, data).then((res: IResponse<IDeleteFeedOutput>) => {
        return res.data as IDeleteFeedOutput;
    });
};
